import { render } from "./MerchantStoresList.vue?vue&type=template&id=3d9e90c6&ts=true"
import script from "./MerchantStoresList.vue?vue&type=script&lang=ts"
export * from "./MerchantStoresList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__